<section [ngStyle]="styles">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
    >
      {{ labelText }}
    </blaze-element-label>
  }
  <div
    #inputContainer
    class="input"
    [ngStyle]="inputWrapperStyles"
    [class.opened]="isMenuOpen"
    [class.readonly]="isReadOnly"
    [class.validation-error]="hasValidationError"
    blazeResized
    (elementResized)="onResized($event)"
    (click)="onInputContainerClick($event)"
  >
    <mat-chip-grid #chipList class="bd-chips">
      @for (item of selection.selected; track item[valueField]) {
        @let itemLabel = item | dataRowFieldValuePipe: labelField;
        <mat-chip-row
          [blazeTooltip]="isTouchMode() ? undefined : itemLabel"
          (removed)="removeTag(item)"
          [ngStyle]="item[valueField] | stylesForTag: tagColorPalette : tagDefaultPalette"
          data-cy="Tags:tagItem"
        >
          <span class="truncate">{{ itemLabel }}</span>
          <button matChipRemove><mat-icon svgIcon="icon_close_8" /></button>
        </mat-chip-row>
      }
      <input
        #filterInput
        type="text"
        autocomplete="off"
        tabindex="0"
        [class.hidden]="isReadOnly"
        [placeholder]="selection.selected.length ? '' : placeholder"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="createTag()"
        (input)="onInputInput($event)"
        (keydown)="onInputKeyDown($event)"
        (keyup)="onInputKeyUp($event)"
      />
    </mat-chip-grid>
    @if (!isReadOnly) {
      <span class="menu-trigger" [class.opened]="isMenuOpen">
        <mat-icon data-cy="Tags:menuTrigger" svgIcon="icon_chevron_down_16" />
      </span>
    }
    <div
      class="menu-fake-trigger"
      [matMenuTriggerFor]="menu"
      [matMenuTriggerRestoreFocus]="false"
    ></div>
  </div>

  <mat-menu
    #menu="matMenu"
    xPosition="after"
    yPosition="below"
    [overlapTrigger]="false"
    [hasBackdrop]="false"
    class="{{ elementKeyRoot }} {{ elementKey }}"
  >
    <ng-template matMenuContent>
      @if (canAddNewItems && filterInput?.value && !itemInList) {
        <button mat-menu-item (click)="onCreateTagClick()">
          <div class="menu-tag elevated"><mat-icon svgIcon="icon_add_32" />Add new</div>
        </button>
      }

      @for (item of displayedOptions | slice: 0 : 1000; track item[valueField]) {
        @let itemLabel = item | dataRowFieldValuePipe: labelField;
        <button
          mat-menu-item
          [blazeTooltip]="isTouchMode() ? undefined : itemLabel"
          [matTooltipShowDelay]="300"
          (click)="selectTag(item, $event)"
          data-cy="Tags:menuItem"
        >
          <div class="menu-tag" [ngStyle]="item[valueField] | stylesForTag: tagColorPalette">
            <span class="truncate">{{ itemLabel }}</span>
          </div>
        </button>
      }

      @if (!displayedOptions.length) {
        <div mat-menu-item>No matches</div>
      }
    </ng-template>
  </mat-menu>
</section>

@if (hasValidationError) {
  <div class="validation" [ngStyle]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}
